import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["auth", "trackerInstance"];
import { useEffect } from 'react';
import { AuthContextProvider } from '../contexts/AuthContext';
import DataSyncOptionsModal from './DataSyncModal/DataSyncOptionsModal';
import { useMaybeReduxAuthContext } from '../hooks/authHooks';
import { setClonedTracker } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const DataSyncModal = _ref => {
  let {
      auth,
      trackerInstance
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const maybeReduxAuth = useMaybeReduxAuthContext();
  useEffect(() => {
    if (trackerInstance) {
      setClonedTracker(trackerInstance);
    }
  }, [trackerInstance]);
  return /*#__PURE__*/_jsx(AuthContextProvider, {
    value: auth || maybeReduxAuth,
    children: /*#__PURE__*/_jsx(DataSyncOptionsModal, Object.assign({}, otherProps))
  });
};
export default DataSyncModal;